import { Basket as BasketV2 } from "src/resources/api/basket/types.api";
import { Project } from "src/resources/api/project/types.api";

export interface ISustainableDevelopmentGoal {
    goalNum: string;
    imageUrl: string;
    description: string;
    title: string;
}

export interface FilterOptions {
    regions: string,
    methodCategory: string,
    registry: string,
    searchTerm: string,
    statuses: string[];
}

export type CarbonOffset = {
    unit: string,
    value: number
}

export interface ProjectFilterOptions {
    regions: string;
    methodCategory: string;
    registry: string;
    searchTerm: string;
    goalNums: {
        label: string;
        value: string
    }[];
}

export enum CART_STEPS {
    CREDITS = 0,
    PAYMENT = 1,
    CONFIRMATION = 2,
}

export type Product = ((BasketV2 | Project) & {
    selectedAmount?: {
        value: number;
        unit: string;
    }
});

export const checkIsProject = (obj: Product): obj is Project => {
    if (!obj) return false;
    return !!Object.hasOwnProperty.call(obj, 'method')
        || !!Object.hasOwnProperty.call(obj, 'registry')
}
